"use client"

import { FC } from "react"
import { useTranslations } from "next-intl"
import {
  EmptyStateWrapper,
  EmptyStateHeading,
  EmptyStateSubtitle,
  BackToHomeButton,
} from "./styles"

interface EmptyStateProps {
  query: string
}

const EmptyState: FC<EmptyStateProps> = ({ query }) => {
  const tHome = useTranslations("Homepage")

  return (
    <EmptyStateWrapper>
      <EmptyStateHeading>{tHome("weCouldntFindWh")}</EmptyStateHeading>
      <EmptyStateSubtitle>
        {tHome("weDidNotFindRes")}{" "}
        <bdi>&ldquo;{query}&rdquo;</bdi>
      </EmptyStateSubtitle>
      <BackToHomeButton href="/">{tHome("backToHomepageCta")}</BackToHomeButton>
    </EmptyStateWrapper>
  )
}

export default EmptyState
